import * as yup from "yup";

export const createCitySchema = (v, t, isEditMode) => {
  return yup.object().shape({
    name: v.string().required(),
    nameEn: v.string().required(),
  });
};
